module.exports = __webpack_public_path__ + "img/stateTwoDesignate.51508583.png";